module.exports = __webpack_public_path__ + "static/media/Deloitte.ec4a60c8.svg";